var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.shouldBeOpen)?_c('portal',{attrs:{"to":"MODAL","order":_vm.key}},[_c('vk-modal',{key:_vm.key,staticClass:"SLIDING-MODAL-OVERLAY",class:[
        _vm.backdropClass,
        {
          'HIDING': _vm.initiateHiding,
          'IGNORE-OPACITY': _vm.transitionName === 'SLIDE-RIGHT' }],attrs:{"has-close-icon":_vm.hasCloseIcon},on:{"close":function($event){return _vm.$emit('secondary')}}},[_c('transition',{attrs:{"name":_vm.transitionName,"appear":""},on:{"after-leave":_vm.onAfterLeave}},[(!_vm.initiateHiding)?_vm._t("body",function(){return [_c('vk-modal-body',{staticClass:"SLIDING-MODAL-BODY"},[_vm._t("default")],2)]}):_vm._e()],2)],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }